import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { GetMessageData, ConfirmMessage, DeleteMessage } from '../../common/actions/moreAction';
import { convertStatusString, dateFormation, isEmpty, isMobilePage } from '../../common/cores';
import Pagenation from '../common/Pagenation';
import Answer from './Answer';
import Blank from './Blank';

const MessageContent = (props) => {

    const { notes, unreadNotes } = props.message;
    const [selected, setSelected] = useState({});
    const [showHis, setShowHis] = useState(false);
    const [ popup, setPopup ] = useState(false);
    const [ popupType, setPopupType ] = useState("");
    const [ message, setMessage ] = useState("");
    // console.log(notes);

    const getMessage = (page) => {
        props.GetMessageData({ page: page, perPage: props.page.perPage });
    }

    const ConfirmMessage = (data, index) => {
        // if (index === selected) setSelected(-1);
        // else setSelected(index);
        // setShowHis(!showHis);
        props.ConfirmMessage(data._id);
    }

    useEffect(() => {
        getMessage(1);
    }, [props.page.perPage])

    const { page } = props;

    const showHisotry = () => {
        setShowHis(!showHis);
    }

    const onSelect = (index, id) => {
        setShowHis(!showHis);
        if(selected === index){
            setSelected(-1);
          }
        else{ 
            setSelected(index);
          }
          console.log("index, id", index, id)
        props.ConfirmMessage(id);
    }

    const deleteAll = () => {
      props.DeleteMessage();
    }

    const onPopup = (value) => {
      setPopup(!popup);
      setPopupType(value);
      if(value === "read"){
        if(popup){
          onSelect(-1, "all");
        }
        setMessage("전체 읽음 처리를 하시겠습니까?");
      }
      if(value === "delete"){
        if(popup){
          deleteAll();
        }
        setMessage("전체 삭제 처리를 하시겠습니까?");
      }
    }

    return (
        <div className="mypage_cont">
            <div className="con_box00">
                <table width="100%" cellSpacing="0" cellPadding="0" style={{ borderSpacing: " 0px" }}>
                    <thead>
                        <tr style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.1)" }}>
                            <th width="20%" className="list_title1"  >{isEmpty(window.lang["번호"]) ? "번호" : window.lang["번호"]}</th>
                            <th className="list_title1"  >{isEmpty(window.lang["제목"]) ? "제목" : window.lang["제목"]}</th>
                            <th width="20%" className="list_title1"  >{isEmpty(window.lang["시간"]) ? "시간" : window.lang["시간"]}</th>
                            <th width="20%" className="list_title1"  >{isEmpty(window.lang["확인"]) ? "확인" : window.lang["확인"]}</th>
                            {/* <th style={{ width: "20%" }} >상태</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            notes.map((note, index) => {
                                return (
                                    <Fragment key={index}>
                                        <tr onClick={() => onSelect(index, note._id)} key={index} style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.1)" }}>
                                            <td className="list1" >{Number(props.page.curPage) * 10 - 9 + index}</td>
                                            <td className="list2" >{note.title}</td>
                                            <td className="list1" >{dateFormation(note.date)}</td>
                                            <td className={`list1`}><span className={`division2  ${note.status == 0 ? "question_wait" : ""}`}>{note.new ? (isEmpty(window.lang["미확인"]) ? "미확인" : window.lang["미확인"]) : (isEmpty(window.lang["확인"]) ? "확인" : window.lang["확인"])}</span></td>
                                            {/* <td >{convertStatusString(note.status)}</td> */}
                                        </tr>
                                        <tr><td colSpan="4" style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.1)", width: "100%", textAlign: "center" }} ><div className={`${selected === index ? "notice-div" : "notice-div-unshow"} white-break-spaces`} dangerouslySetInnerHTML={{ '__html': note.description }}></div></td></tr>
                                    </Fragment>
                                )
                            })
                        }
                        {
                            notes.length === 0 &&
                            <tr>
                                <td colSpan="4" className="no-data">
                                    <span
                                        className="text" style={{ justifyContent: "center" }}>
                                        데이터가 없습니다
                                    </span></td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <Pagenation page={page.curPage}
                totalPage={page.totalPage}
                getPage={getMessage}
                perPage={10} />
            <div className="con_box10">
                <div className="btn_wrap_right">
                    <ul>
                        <li><a><span className="btn2_1 m-r-2" onClick={() => onPopup("read")}>{isEmpty(window.lang["전체읽음"]) ? "전체읽음" : window.lang["전체읽음"]}</span></a></li>
                        <li><a><span className="btn2_2" onClick={() => onPopup("delete")}>{isEmpty(window.lang["전체삭제"]) ? "전체삭제" : window.lang["전체삭제"]}</span></a></li>
                    </ul>
                </div>
            </div>

            <div className="dialog" style={{ display: popup ? "flex" : "none", backgroundColor: !popup && '#00000000', transition: "0.5s", scale: popup ? "1" : "0" }}>
                <div className="container popup_color" style={{ display: "block" }}>
                    <div className="padding-20 d-flex">
                        <img src="../images/question.png" style={{ margin: "20px auto 0 auto" }} alt="" />
                    </div>
                    <div className="justify-center  d-flex betting_modal_text">
                        <span style={{ width: "100%", textAlign: "center" }}>{message}</span>
                    </div>
                    <div className=" d-flex w-100 justify-content-center padding-15 betting_modal_text">
                        <span className="popup-btn" onClick={() => onPopup(popupType)}>네</span>
                        <span className="popup-btn" onClick={() => onPopup("")}>아니오</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    isAuthenticated: state.user.isAuthenticated,
    message: state.more.message,
    page: state.page
});

export default connect(mapStateToProps, { GetMessageData, ConfirmMessage, DeleteMessage })(MessageContent);


// WEBPACK FOOTER //
// ./src/components/account/MessageContent.js